import { convertMonth } from "@/helpers/convertMonth"
import moment from "moment"

export const toggleLike = (value: boolean, isFetching, submitForm, setIsLiked, data, obj, csrf) => {
    if (!isFetching) {
        submitForm({ obj, id: data.id })
        setIsLiked(value)
    }
    sessionStorage.setItem(`article${data.id}`, `${value}`)
    sessionStorage.setItem(`token`, `${csrf}`)
}

export const formatDate = date => {
    const originalDate = moment(date)

    return `${originalDate.format('DD')} ${convertMonth(originalDate.format('MMMM'), true)}`
}